import React from 'react';

import { cn } from '@pray/shared/utils/styles';

import { colors, typography } from '../../foundations';
import { Accordion } from '../Accordion/Accordion';
import Text from '../Text/Text';

export interface FAQProps {
  title?: string;
  description?: string;
  className?: string;
  children: React.ReactNode;
}

export default function FAQ({ title, description, className, children }: FAQProps) {
  return (
    <div className={cn('w-full max-w-2xl mx-auto py-12', className)}>
      {title && (
        <Text variant={typography.heading_2xl} color={colors.text_primary} className="mb-4 text-center">
          {title}
        </Text>
      )}
      {description && (
        <Text variant={typography.body_lg} className="mb-8 text-center text-gray-600">
          {description}
        </Text>
      )}
      <Accordion>{children}</Accordion>
    </div>
  );
}
